import {Directive, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {HigherEducationInstitution} from "./higher-education-institution";
import {HigherEducationInstitutionsService} from "../higher-education-institutions.service";
import {Results} from "../../core/results";
import {
  HigherEducationInstitutionType
} from '../../higher-education-institution-types/higher-education-institution-type/higher-education-institution-type';
import {Application} from '../../applications/application/application';
declare var $: any;

@Directive({
  selector: '[appHigherEducationInstitution]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HigherEducationInstitutionDirective),
    multi: true
  }]
})
export class HigherEducationInstitutionDirective implements ControlValueAccessor, OnInit {

  @Input() private higherEducationInstitution: HigherEducationInstitution;
  @Input() private application: Application = new Application();
  @Input() private higherEducationInstitutionType: HigherEducationInstitutionType;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: HigherEducationInstitutionsService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Name of University/TVET College',
      allowClear: true,

      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 100;
          if(that.higherEducationInstitutionType) {
            that.service.searchByType(page, perPage, 'ASC', 'name', params.data.term, that.higherEducationInstitutionType.id).subscribe((ret: Results<HigherEducationInstitution>) => {
              success(ret);
            });
          } else {
            that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<HigherEducationInstitution>) => {
              success(ret);
            });
          }


        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
              disabled: that.application?.selectedHigherEducationInstitutionOne?.id === obj.id || that.application?.selectedHigherEducationInstitutionTwo?.id === obj.id || that.application?.selectedHigherEducationInstitutionThree?.id === obj.id
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.higherEducationInstitution = JSON.parse(e.params.data.id);
      that.propagateChange(that.higherEducationInstitution);
      if(that.onSelect) {
        that.onSelect.emit();
      }

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.higherEducationInstitution = null;
      that.propagateChange(that.higherEducationInstitution);
      if(that.onSelect) {
        that.onSelect.emit();
      }
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(higherEducationInstitution: HigherEducationInstitution): void {
    this.higherEducationInstitution = higherEducationInstitution;
    this.propagateChange(this.higherEducationInstitution);
    const that = this;
    if (this.higherEducationInstitution !== undefined && this.higherEducationInstitution !== null) {
      const option = new Option(higherEducationInstitution.name, JSON.stringify(higherEducationInstitution), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    } else {
      const option = new Option('', '', true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.higherEducationInstitution;
  }

  set value(v: any) {
    if (v !== this.higherEducationInstitution) {
      this.higherEducationInstitution = v;
      this.propagateChange(v);
    }
  }
}
